import { i18n } from 'i18n';

export const ROUTE_PATH = '/projects';
export const TITLE = i18n._('Projects');
